import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useClassroomGetList = (skip = false) => {
  // TODO -- LESS-1153: this hook should have a setter param, so that clients of this hook can pass their state setter in
  // for this hook to set after the fetch
  return useRestQuery(`${MONOLITH_ORIGIN}/api/v2/classroom/`, skip);
};

export default useClassroomGetList;
